import React, { useState } from "react";
import {
  Alert,
  Button,
  Stack,
  TextField,
} from "@mui/material";
import toast from "react-hot-toast";
import { manualCredit, manualDebit } from "../../Apis/Wallet-api";
import WalletPageShell from "../../Components/Wallet/WalletPageShell";
import WalletSelect from "../../Components/Wallet/WalletSelect";

export default function ManualAdjustmentPage() {
  const [walletId, setWalletId] = useState("");
  const [amount, setAmount] = useState("");
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const run = async (kind) => {
    if (!walletId || !amount) {
      toast.error("Wallet and amount are required.");
      return;
    }
    setLoading(true);
    try {
      if (kind === "credit") {
        await manualCredit(walletId, amount, notes);
        toast.success("Manual credit applied.");
      } else {
        await manualDebit(walletId, amount, notes);
        toast.success("Manual debit applied.");
      }
      setAmount("");
      setNotes("");
    } catch (err) {
      toast.error(err.response?.data?.message || "Adjustment failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <WalletPageShell
      heading="Manual wallet adjustment"
      subtitle="Ops credit / debit (manual credit / manual debit) via admin JWT — no OTP"
    >
      <Stack spacing={2} maxWidth={480}>
        <Alert severity="info" variant="outlined">
          Admin JWT debit does not require step-up. Agent API debit still requires
          password + OTP when step-up is enabled.
        </Alert>
        <WalletSelect value={walletId} onChange={setWalletId} />
        <TextField
          label="Amount"
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          fullWidth
          size="small"
        />
        <TextField
          label="Notes"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          fullWidth
          size="small"
          multiline
          minRows={2}
        />
        <Stack direction="row" spacing={1}>
          <Button
            variant="contained"
            disabled={loading}
            onClick={() => run("credit")}
          >
            Manual credit
          </Button>
          <Button
            variant="outlined"
            color="warning"
            disabled={loading}
            onClick={() => run("debit")}
          >
            Manual debit
          </Button>
        </Stack>
      </Stack>
    </WalletPageShell>
  );
}
